'use client'
import FoodCard from '@/components/Cards/FoodCard'
import HeroCard from '@/components/Cards/HeroCard'
import LargeCard from '@/components/Cards/LargeCard'
import { Heading } from '@/components/Common'
import { useNews } from '@/hooks/useNews'
import React from 'react'

const TravelAndFoodSection = () => {
  const { allNews: travelItems, isLoading: isTravelLoading } = useNews({
    menuSlug: 'du-lich',
  })
  const { allNews: foodItems, isLoading: isFoodLoading } = useNews({
    size: 10,
    menuSlug: 'am-thuc',
  })
  return (
    <section className="container mt-4">
      <Heading>Du lịch - Ẩm thực</Heading>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-7 lg:col-span-5">
          <LargeCard data={travelItems} isLoading={isTravelLoading} />
        </div>
        <div className="col-span-12 md:col-span-5 lg:col-span-3 flex flex-col gap-4">
          {isTravelLoading
            ? Array.from({ length: 2 }).map((_, index) => (
                <div key={index}>
                  <HeroCard isLoading />
                </div>
              ))
            : travelItems
                .slice(8)
                .map((news) => (
                  <HeroCard
                    key={news.id}
                    title={news.title}
                    categoryName={news.categoryName}
                    categoryId={news.categoryId}
                    imageUrl={news.imageUrl}
                    link={news.slug}
                  />
                ))}
        </div>
        <div className="col-span-12 lg:col-span-4 max-h-[590px] overflow-y-auto">
          {isFoodLoading
            ? Array.from({ length: 8 }).map((_, index) => <FoodCard key={index} isLoading={true} />)
            : foodItems.map((item) => (
                <FoodCard
                  key={item.id}
                  imageUrl={item.imageUrl}
                  title={item.title}
                  description={item.description}
                  categoryName={item.categoryName}
                  link={item.slug}
                />
              ))}
        </div>
      </div>
    </section>
  )
}

export default TravelAndFoodSection
